import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import { formatCurrency, getAccountHolderName } from '../../generalFunctions';
import Header from './common/Header';
import Signature from './common/Signature';
import { PDF_ALL_MARGIN, PDF_LEFT_MARGIN, PDF_RIGHT_MARGIN } from '../../constants';

const styles = StyleSheet.create({
    rowView: {
        display: 'flex', flexDirection: 'row', borderTop: '1px solid #000', paddingTop: 8, paddingBottom: 8, textAlign: "center"
    }
});

const CreditNotePdf = (props) => {
    const tableData = {
        column: ["record", "perticulars", "amount"],
        data: props.data.perticulars
    }

    return (
        <Page style={{ paddingLeft: PDF_LEFT_MARGIN, margin: PDF_ALL_MARGIN, paddingRight: PDF_RIGHT_MARGIN }} id={props.data.id} size="A4">
            <View style={{ border: 2, padding: 5 }}>
                <Header title={props.pdfType === "debitNote" ? "D  E  B  I  T     N  O  T  E" : "C  R  E  D  I  T     N  O  T  E"} date={props.data.date} id={props.data.id} />

                <View style={{ flexDirection: "row", padding: 10, marginBottom: 5 }}>
                    <Text style={{
                        fontSize: 11,
                        flexDirection: "column",
                        flexGrow: 0.05
                    }}>NAME:</Text>
                    <Text style={{
                        fontSize: 11,
                        flexDirection: "column",
                        marginRight: 20,
                        flexGrow: 1,
                        borderBottomColor: '#112131',
                        borderBottomStyle: 'solid'
                    }}>{getAccountHolderName(props.data.accountId)}</Text>
                </View>

                <Fragment>
                    <View style={styles.rowView}>
                        {tableData["column"].map((c) => <Text style={{
                            width: `${100 / tableData["column"].length}%`, fontSize: 11
                        }}>{c.toUpperCase()}</Text>)}
                    </View>
                    {tableData["data"].map((rowData) => <>
                        <View style={{ display: 'flex', flexDirection: 'row', borderTop: '1px solid #000', paddingTop: 8, paddingBottom: 8, textAlign: "center" }}>
                            {tableData["column"].map((c, index) =>
                                <Text style={{ width: `${100 / tableData["column"].length}%`, fontSize: 11, textAlign: index === 2 ? "right" : "center", marginRight: index === 2 ? 60 : 0 }}>{rowData[c]}</Text>
                            )}
                        </View>
                    </>)}
                </Fragment>

                <View style={{ flexDirection: "row", padding: 10, marginBottom: 5 }}>
                    <Text style={{
                        fontSize: 11,
                        flexDirection: "column",
                        flexGrow: 0.05,
                        alignSelf: "flex-end"
                    }}>TOTAL AMOUNT:</Text>
                    <Text style={{
                        fontSize: 11,
                        flexDirection: "column",
                        marginRight: 10,
                        flexGrow: 1,
                        alignSelf: "flex-end"
                    }}>{formatCurrency(props.data.totalAmount)}</Text>
                </View>

                <Signature />
            </View>
        </Page>
    );
}

export default CreditNotePdf;